import React from "react";
import { Field, Switch } from "@fluentui/react-components";

const SwitchField = ({ name, label, value, onChange }) => (
  <Field label={label}>
    <Switch checked={value} onChange={(e) => onChange(name, e.target.checked)} />
  </Field>
);

export default SwitchField;
